<template>
	<payments-table :payments="payments" simplify title-bar>
		<create-payment />
	</payments-table>
</template>
<script>
import PaymentsTable from '@/Pages/Backend/Payments/Table'
import CreatePayment from '@/Pages/Backend/Payments/Create'

export default {
	components: {
		PaymentsTable,
		CreatePayment
	},
	props: {
		payments: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			//
		}
	}
}
</script>
